import { useNavigate, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Pagination } from '@mui/material';
import { useGetProductContentsQuery } from '../features/api/rest/apiProductContentsSlice';
import BoardCard from './BoardCard';
import Spinner from './Spinner';
import Error from './Error';

function BoardResults({ ean }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const contentsForPage = parseInt(searchParams.get('c_psize'), 10) || 5;
  const contentPage = parseInt(searchParams.get('c_page'), 10) || 1;
  const ordering = searchParams.get('c_ordering') || '-id';
  const { contents, contentsCount, isLoading, isFetching, isError } = useGetProductContentsQuery(
    { ean: ean, ordering: ordering, page: contentPage, psize: contentsForPage },
    {
      selectFromResult: ({ data }) => ({
        contents: data?.results,
        contentsCount: data?.count,
      }),
    }
  );
  const handlePageChange = (page) => {
    searchParams.set('c_page', page);
    navigate(`/products/${ean}?${searchParams.toString()}`);
  };

  if (isLoading || isFetching) return <Spinner />;

  if (isError) return <Error />;

  const pagination = contentsCount > contentsForPage && <Pagination sx={{ my: 2 }} count={Math.ceil(contentsCount / contentsForPage)} page={contentPage} onChange={(event, newPage) => handlePageChange(newPage)} />;

  return (
    <Box>
      {pagination}
      {contents &&
        contents.map((content, index) => {
          return <BoardCard key={content.id} organizationName={content.organization.name} content={content.content} />;
        })}
      {pagination}
    </Box>
  );
}

BoardResults.propTypes = {
  ean: PropTypes.string.isRequired,
};

export default BoardResults;
